import { useEffect } from "react";
import useApiData from "../../components/DataSource/useApiData";
import Status from "../../components/DataSource/status";

export const useJson = (body, enable = true) => {
    const { status } = useApiData();

    useEffect(() => {
        if (body && status === Status.LOADED && enable) {
            const script = document.createElement('script');
            const id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);

            script.innerHTML = body.replace(/\\n/g, '').replace( /(<([^>]+)>)/ig, '');
            script.type = 'application/ld+json';
            script.id = id;

            document.head.appendChild(script);

            return () => {
                document.getElementById(id).remove();
            }
        }
    }, [body, status, enable]);
}
